export const SITE_DOMAIN = 'работа-россия.site';
export const SITE_DOMAIN_ASCII = 'xn----7sbad1b7ackflag0p.site';
export const SITE_URL = `https://${SITE_DOMAIN}`;
export const SITE_URL_ASCII = `https://${SITE_DOMAIN_ASCII}`;

export const COMPANY = {
    inn: '381111872209',
    ogrn: '326595800032624',
    address: 'г. Рязань, ул. Каширина, д. 1',
    email: `info@${SITE_DOMAIN_ASCII}`,
    workHours: 'Пн–Пт, 9:00–18:00 (МСК)',
    siteUrl: SITE_URL
};

export const SALARY_FROM = 320000;
export const SALARY_TO = 710000;

export const SALARY_DISCLAIMER =
    'Указанный уровень дохода — ориентировочный при полной вахте. Точная сумма зависит от должности, объекта и условий работодателя.';

export const WORK_REGIONS = [
    'Белгородская область',
    'Донецкая область',
    'Курская область',
    'Луганская область',
    'Республика Крым',
    'Ростовская область'
];

export const PROFESSIONS = [
    {
        title: 'Сопровождение грузов',
        description: 'охрана и сопровождение грузов по железной и автомобильной дороге.',
        image: '/images/guard-cargo.png',
        salaryFrom: 320000,
        salaryTo: 710000,
        schedule: 'Вахтовый метод (15/15, 30/30)',
        requirements: [
            'Готовность к вахтовому методу',
            'Отсутствие судимости'
        ],
        details: [
            'Сопровождение грузов автомобильными и железнодорожными колоннами',
            'Контроль сохранности груза на маршруте',
            'Соблюдение регламента охраны и техники безопасности'
        ]
    },
    {
        title: 'Охрана складских комплексов',
        description: 'охрана складских комплексов и контроль доступа на объект.',
        image: '/images/guard-warehouse.png',
        salaryFrom: 320000,
        salaryTo: 710000,
        schedule: 'Вахтовый метод (15/15, 30/30)',
        requirements: [
            'Опыт работы на объектах приветствуется',
            'Отсутствие судимости'
        ],
        details: [
            'Охрана складских территорий и помещений',
            'Контроль пропускного режима и доступа',
            'Обход объекта и реагирование по регламенту'
        ]
    },
    {
        title: 'Патрулирование местности',
        description: 'охрана и патрулирование местности на закреплённых участках.',
        image: '/images/guard-patrol.png',
        salaryFrom: 320000,
        salaryTo: 710000,
        schedule: 'Вахтовый метод (15/15, 30/30)',
        requirements: [
            'Физическая выносливость',
            'Отсутствие судимости'
        ],
        details: [
            'Патрулирование закреплённой территории',
            'Выявление нарушений и оповещение по инструкции',
            'Ведение служебной документации'
        ]
    },
    {
        title: 'Охрана мостов',
        description: 'охрана мостов и инфраструктурных объектов на маршрутах.',
        image: '/images/guard-bridge.png',
        salaryFrom: 320000,
        salaryTo: 710000,
        schedule: 'Вахтовый метод (15/15, 30/30)',
        requirements: [
            'Готовность к работе на открытых объектах',
            'Отсутствие судимости'
        ],
        details: [
            'Охрана мостов и прилегающей инфраструктуры',
            'Контроль доступа и обход объекта',
            'Соблюдение режима и регламента охраны'
        ]
    }
];

export const BENEFITS = [
    {
        image: '/images/work-1.png',
        alt: 'Официальное трудоустройство',
        title: 'Официальное трудоустройство',
        description: 'Оформление по трудовому договору, белая заработная плата и социальные гарантии.'
    },
    {
        image: '/images/work-2.png',
        alt: 'Проживание и питание',
        title: 'Проживание и питание за счёт компании',
        description: 'Проживание в вахтовых условиях и организованное питание на период работы.'
    },
    {
        image: '/images/work-3.png',
        alt: 'Оплата больничных листов',
        title: 'Оплата больничных листов и пенсионных отчислений',
        description: 'Выплаты по больничным и пенсионные отчисления в соответствии с законодательством.'
    }
];

export const FAQ_ITEMS = [
    {
        question: 'Кто является работодателем?',
        answer:
            'Мы оказываем информационные услуги по подбору персонала. Трудоустройство происходит у партнёрских организаций — работодателей, с которыми мы сотрудничаем. Конкретного работодателя и условия вы узнаете при консультации после подачи заявки.'
    },
    {
        question: 'Платно ли подавать заявку?',
        answer:
            'Нет, подача заявки и консультация по вакансиям бесплатны. Мы не берём денег с соискателей за подбор или трудоустройство.'
    },
    {
        question: 'Как быстро перезвонят после заявки?',
        answer:
            'Обычно мы связываемся в течение одного рабочего дня в часы работы: Пн–Пт, 9:00–18:00 (МСК). В выходные заявки обрабатываются в понедельник.'
    },
    {
        question: 'Оплачивается ли проезд к месту работы?',
        answer:
            'Проезд к месту работы оплачивается работодателем. Точные условия компенсации проезда уточняются при консультации и зависят от региона и вакансии.'
    },
    {
        question: 'Как происходит оформление?',
        answer:
            'Трудоустройство осуществляется официально — по трудовому договору с работодателем. Оформляются все необходимые документы, производятся отчисления в соответствии с законодательством РФ.'
    },
    {
        question: 'Что такое подъёмные и когда их выплачивают?',
        answer:
            'Подъёмные — единовременная выплата при трудоустройстве, которую предоставляет работодатель. Размер и условия выплаты зависят от вакансии и региона и оговариваются индивидуально.'
    },
    {
        question: 'Как отозвать согласие на обработку персональных данных?',
        answer:
            `Направьте запрос на электронную почту ${COMPANY.email}. Мы прекратим обработку данных в сроки, установленные законом.`
    }
];

export const formatSalary = (from, to) =>
    `от ${from.toLocaleString('ru-RU')} до ${to.toLocaleString('ru-RU')} ₽`;
